import SourcesPage from './SourcesPage';
import adminPageReducer from './reducer';

export { adminPageReducer };
export default SourcesPage;
